/** ****************************************************************************
 * URL Validation Utility
 *
 * Validates URLs against protocol and domain allowlists to prevent
 * injection of arbitrary external resources.
 *
 * @file   URL validation for partner-supplied fontUrl and similar fields
 * @since  2.0.0
 **************************************************************************** */

const ALLOWED_FONT_DOMAINS: string[] = [
  'fonts.googleapis.com',
  'fonts.gstatic.com',
  'use.typekit.net',
  'fast.fonts.net',
  'cdn.bperx.com',
]

/**
 * Validates that a font URL uses HTTPS and points to an allowed domain.
 *
 * @param url The font URL to validate
 * @returns true if the URL is safe to load as a stylesheet
 */
export function isValidFontUrl(url: string): boolean {
  try {
    const parsed = new URL(url)
    if (parsed.protocol !== 'https:') return false
    return ALLOWED_FONT_DOMAINS.some(domain => parsed.hostname === domain)
  } catch {
    return false
  }
}
